import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-surveillant',
  templateUrl: './home-surveillant.component.html',
  styleUrls: ['./home-surveillant.component.scss']
})
export class HomeSurveillantComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
